import { jsxs as _jsxs } from "react/jsx-runtime";
function formatTokens(n) {
    if (n >= 1_000_000)
        return `${(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000)
        return `${(n / 1_000).toFixed(1)}K`;
    return String(n);
}
/**
 * Small status bar showing cumulative token usage for the session.
 */
export function UsageIndicator({ usage }) {
    if (usage.totalTokens === 0)
        return null;
    return (_jsxs("div", { className: "flex items-center space-x-3 text-xs text-gray-500", children: [_jsxs("span", { title: "Input tokens", children: ["In: ", formatTokens(usage.inputTokens)] }), _jsxs("span", { title: "Output tokens", children: ["Out: ", formatTokens(usage.outputTokens)] }), _jsxs("span", { title: "Total tokens", children: ["Total: ", formatTokens(usage.totalTokens)] })] }));
}
//# sourceMappingURL=UsageIndicator.js.map